import { KeyVal } from './types';

export const apiObjectToKeyVal = <
  K extends string,
  V,
  T extends object,
  Fallback = [KeyVal<K, V>]
>(
  obj?: Record<K, V>,
  config?: {
    modifier?: (item: [K, V]) => T;
    fallback?: Fallback;
  }
): (KeyVal<K, V> & T)[] | Fallback => {
  const entries = obj ? Object.entries(obj) : [];
  if (!entries.length) {
    return config && 'fallback' in config
      ? (config.fallback as Fallback)
      : ([{ key: '', value: '' }] as Fallback);
  }
  return entries.map((item) => {
    const [key, value] = item as [K, V];
    return {
      key,
      value,
      ...(config?.modifier ? config.modifier(item as [K, V]) : {}),
    };
  }) as (KeyVal<K, V> & T)[];
};

export const reduceKeyVal = <K extends string, V>(
  keyVals?: KeyVal<K, V>[]
): Record<K, V> | undefined => {
  const filtered = keyVals?.filter(({ key }) => !!key);
  if (!filtered?.length) {
    return undefined;
  }
  return filtered.reduce((acc, { key, value }) => {
    acc[key] = value;
    return acc;
  }, {} as Record<K, V>);
};
